export default __webpack_public_path__ + "static/media/image 11.b0425f5c.svg";